export default "__VITE_ASSET__PoKrO2sd__"